/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css2?family=Muli:ital,wght@0,400;0[_ngcontent-%COMP%], 500[_ngcontent-%COMP%];0[_ngcontent-%COMP%], 700[_ngcontent-%COMP%];1[_ngcontent-%COMP%], 400&display=swap)[_ngcontent-%COMP%];section[_ngcontent-%COMP%]{padding:2rem;display:grid;grid-auto-flow:row;grid-row-gap:2rem;height:calc(100vh - 46px);grid-auto-rows:min-content}"];
export { styles as styles };
